import { render, staticRenderFns } from "./GameCharts.vue?vue&type=template&id=55e3cf9e&scoped=true&"
import script from "./GameCharts.vue?vue&type=script&lang=js&"
export * from "./GameCharts.vue?vue&type=script&lang=js&"
import style0 from "./GameCharts.vue?vue&type=style&index=0&id=55e3cf9e&scoped=true&lang=css&"
import style1 from "./GameCharts.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e3cf9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VProgressCircular})
